import { render, staticRenderFns } from "./DialogTransparentComponent.vue?vue&type=template&id=84c83bc6&scoped=true&"
import script from "./DialogTransparentComponent.vue?vue&type=script&lang=ts&"
export * from "./DialogTransparentComponent.vue?vue&type=script&lang=ts&"
import style0 from "./DialogTransparentComponent.vue?vue&type=style&index=0&id=84c83bc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c83bc6",
  null
  
)

export default component.exports